const cache = new Map<string, Intl.NumberFormat>();

export function getNumberFormat(
	locale: Intl.LocalesArgument,
	options: Intl.NumberFormatOptions = {},
): Intl.NumberFormat {
	const key = `${locale?.toString()}:${JSON.stringify(options)}`;
	let format = cache.get(key);
	if (!format) {
		format = new Intl.NumberFormat(locale, options);
		cache.set(key, format);
	}
	return format;
}
